'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Predicate2 = require('../abstract/Predicate');

var _Predicate3 = _interopRequireDefault(_Predicate2);

var _QueryNode = require('../QueryNode.js');

var _QueryNode2 = _interopRequireDefault(_QueryNode);

var _Descriptor = require('./Descriptor');

var _Descriptor2 = _interopRequireDefault(_Descriptor);

var _CommitDate = require('./CommitDate');

var _CommitDate2 = _interopRequireDefault(_CommitDate);

var _UploadDate = require('./UploadDate');

var _UploadDate2 = _interopRequireDefault(_UploadDate);

var _UploadUser = require('./UploadUser');

var _UploadUser2 = _interopRequireDefault(_UploadUser);

var _DocumentStatus = require('./DocumentStatus');

var _DocumentStatus2 = _interopRequireDefault(_DocumentStatus);

var _AndCondition = require('../conditions/AndCondition');

var _AndCondition2 = _interopRequireDefault(_AndCondition);

var _OrCondition = require('../conditions/OrCondition');

var _OrCondition2 = _interopRequireDefault(_OrCondition);

var _NotCondition = require('../conditions/NotCondition');

var _NotCondition2 = _interopRequireDefault(_NotCondition);

var _BinderIdPredicate = require('../engine/BinderIdPredicate');

var _BinderIdPredicate2 = _interopRequireDefault(_BinderIdPredicate);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentTypePredicate = function (_Predicate) {
    (0, _inherits3.default)(DocumentTypePredicate, _Predicate);

    function DocumentTypePredicate(params) {
        var _ref;

        (0, _classCallCheck3.default)(this, DocumentTypePredicate);

        for (var _len = arguments.length, children = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            children[_key - 1] = arguments[_key];
        }

        params = _QueryNode2.default.sanitizeParams.apply(_QueryNode2.default, [params].concat(children));
        params = (0, _assign2.default)(params, {
            type: 'DocumentTypePredicate',
            canHaveChildren: true,
            accepts: [_Descriptor2.default]
        });
        return (0, _possibleConstructorReturn3.default)(this, (_ref = DocumentTypePredicate.__proto__ || (0, _getPrototypeOf2.default)(DocumentTypePredicate)).call.apply(_ref, [this, params].concat(children)));
    }

    (0, _createClass3.default)(DocumentTypePredicate, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            if (this.documentType == null) {
                return null;
            }
            var queryFragment = { 'documentType.id': { $eq: this.documentTypeId } };
            if (this.children.length > 0) {
                if (this.children.some(function (child) {
                    return !child.toQueryFragment();
                })) {
                    // if any of the children is falsy, the predicate will be resolved to false
                    return null;
                }
                var childrenFragments = this.children.map(function (child) {
                    return child.toQueryFragment();
                });
                queryFragment = {
                    $and: [queryFragment].concat(childrenFragments)
                };
            }
            return queryFragment;
        }
    }, {
        key: 'documentType',
        get: function get() {
            return this.data.documentType;
        },
        set: function set(value) {
            this.data.documentType = value;
        }
    }, {
        key: 'documentTypeId',
        get: function get() {
            return this.documentType && this.documentType.id || -1;
        }
    }]);
    return DocumentTypePredicate;
}(_Predicate3.default);

DocumentTypePredicate.defaultData = {
    documentType: null
};

// TODO: Deprecate the idea of DocumentTypes having child nodes
// In favor of them just being simple predicates
DocumentTypePredicate.canHaveChildren = true;
DocumentTypePredicate.accepts = [_Descriptor2.default, _CommitDate2.default, _DocumentStatus2.default, _UploadDate2.default, _UploadUser2.default, _AndCondition2.default, _OrCondition2.default, _NotCondition2.default, _BinderIdPredicate2.default];
DocumentTypePredicate.displayName = 'Document Type';

_QueryNodeRegistry2.default.register(DocumentTypePredicate);
exports.default = DocumentTypePredicate;